import { DataGrid, LoadPanel, ScrollView, Tooltip } from 'devextreme-react';
import { Column } from 'devextreme-react/data-grid';
import { useEffect, useState } from 'react';
import Popup from 'devextreme-react/popup';
import { useAppSelector } from '../../../../../contexts/hooks';
import { useScreenSize } from '../../../../../utils/media-query';
import moment from 'moment';

import { UseApiResults } from '../../../../../api/api.results';
import { useApiConfiguration } from '../../../../../api/api.configuration';

export const ModalOpportunity = ({ visible, setVisible }) => {
  const [data, setData] = useState<any[]>([]);
  const [dataServices, setDataServices] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const generalOportunity = useAppSelector((x) => x.configuration.Data?.Config_General.find((cfg) => cfg.Cgn_Nombre === 'GeneralOpportunity')?.Cgn_Resultado);
  const { isMedium, isSmall, isXSmall } = useScreenSize();
  const idOrd = useAppSelector((x) => x.globalOrders.CurrentOrder.IdOrder);
  const { getEstudiesByOrder } = UseApiResults();
  const { getServices } = useApiConfiguration();

  useEffect(() => {
    getServices().then((res) => {
      setDataServices(res);
    });
  }, []);

  useEffect(() => {
    if (visible && idOrd && idOrd !== -1) {
      setLoading(true);
      getEstudiesByOrder(idOrd).then((res) => {
        setData(res);
        setLoading(false);
      });
    }
  }, [visible]);

  const calculateOpportunity = (row) => {
    const start = moment(row.Roe_FechaInicioTracking); // Fecha de inicio
    const end = row.Roe_FechaFinTracking ? moment(row.Roe_FechaFinTracking) : moment(); // Fecha de fin o actual
    if (!start.isValid() || !end.isValid()) return 0; // Verifica si las fechas son válidas
    return end.diff(start, 'minutes'); // Calcula la diferencia en minutos
  };

  const calculateGeneralOpportunity = () => {
    if (!data.length) return 0;

    // Encuentra la fecha de inicio más antigua
    const earliestStart = data
      .map((row) => moment(row.Roe_FechaInicioTracking))
      .filter((date) => date.isValid()) // Filtra fechas válidas
      .reduce((min, date) => (date.isBefore(min) ? date : min), moment());

    // Encuentra la fecha de fin más reciente (o la fecha actual si alguna es null)
    const latestEnd = data
      .map(
        (row) => (row.Roe_FechaFinTracking ? moment(row.Roe_FechaFinTracking) : moment()) // Usa la fecha actual si Roe_FechaFinTracking es null
      )
      .filter((date) => date.isValid()) // Filtra fechas válidas
      .reduce((max, date) => (date.isAfter(max) ? date : max), moment());

    // Calcula la diferencia en minutos entre la fecha más antigua y la más reciente
    return latestEnd.diff(earliestStart, 'minutes');
  };

  const getOpportunityValue = (row) => {
    const serviceOpportunity = dataServices.find((service) => service.Se_Oportunidad)?.Se_Oportunidad;
    return serviceOpportunity || generalOportunity;
  };

  const handleClose = () => {
    setVisible(false);
  };

  return (
    <Popup visible={visible} fullScreen={isMedium || isSmall || isXSmall} width={600} maxHeight={700} title='Oportunidad' onHiding={handleClose} showCloseButton={true}>
      <ScrollView>
        <div style={{ marginBottom: '20px', textAlign: 'center' }}>
          <h3>Oportunidad General</h3>
          <div
            style={{
              fontSize: '24px',
              fontWeight: 'bold',
              color: calculateGeneralOpportunity() > Number(generalOportunity) ? 'red' : 'green',
            }}>
            {calculateGeneralOpportunity()} minutos
          </div>
        </div>

        <DataGrid id='dataTg' dataSource={data} showBorders={true} rowAlternationEnabled={true} columnAutoWidth={true}>
          <Column dataField='Estudio.Es_Nombre' caption='Estudio' />
          <Column
            caption='Oportunidad'
            alignment='center'
            cellRender={({ data }) => {
              const opportunity = calculateOpportunity(data); // Tiempo transcurrido
              const value = getOpportunityValue(data); // Valor base
              const isExpired = opportunity > value; // Determina si está vencida

              return (
                <span
                  id={`item${data.Roe_Id}`}
                  style={{ color: isExpired ? 'red' : 'green' }} // Rojo si está vencida, verde si está vigente
                >
                  {opportunity} Minutos
                  <Tooltip target={`#item${data.Roe_Id}`} showEvent='mouseenter' hideEvent='mouseleave' position='top'>
                    Inicio: {moment(data.Roe_FechaInicioTracking).format('YYYY-MM-DD HH:mm:ss')}
                    <br />
                    Fin: {data.Roe_FechaFinTracking ? moment(data.Roe_FechaFinTracking).format('YYYY-MM-DD HH:mm:ss') : 'En curso'}
                    <br />
                    Oportunidad Base: {value} minutos
                  </Tooltip>
                </span>
              );
            }}
          />
        </DataGrid>

        <LoadPanel visible={loading} position={{ of: '#dataTg' }} />
      </ScrollView>
    </Popup>
  );
};
